const DATA_INSIGHTS_API =
  process.env.NEXT_PUBLIC_FORCE_BACKEND || process.env.NEXT_PUBLIC_DATA_INSIGHTS_API_URL

export { DATA_INSIGHTS_API }
